/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-05.
 * Hardcoded pre invoices.
 */
export const creditNote = {
    invoiceItem: {
        concept: 'Nota de crédito',
        applicable: 'No Aplica',
        applicableRepresentation: 'No Aplica',
        tax: 16,
        aditionalTax: 0,
        retentions: 0
    },
    priceValue: 0,
    expenseType: ''
};



// WEBPACK FOOTER //
// ./data/preInvoice.js